import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import MasterCard from "../../../assets/images/PaymentMethods/MasterCard.png";
import PayPal from "../../../assets/images/PaymentMethods/PayPal.png";
import JazzCashEasyPaisa from "../../../assets/images/PaymentMethods/JazzCashEasyPaisa.png";
import CashOnDelivery from "../../../assets/images/PaymentMethods/CashOnDelivery.png";
import BankTransfer from "../../../assets/images/PaymentMethods/BankTransfer.png";
import Maelano from "../../../assets/images/PaymentMethods/Maelano.png";
import ApplePay from "../../../assets/images/PaymentMethods/ApplePay.png";
import GooglePay from "../../../assets/images/PaymentMethods/GooglePay.png";
import styles from "./PaymentMethod.module.scss";
import { Button, Col, Input, Row } from "reactstrap";
import { RiArrowRightDoubleLine } from "react-icons/ri";
import DropDown from "./DropDown";
import ScrollToTop from "../../../components/common/ScrollToTop/ScrollToTop";

const PaymentMethod = ({ setActiveTab }) => {
  const paymentMethods = [
    {
      img: MasterCard,
      type: "Credit/Debit Card",
    },
    {
      img: PayPal,
      type: "Paypal",
    },
    {
      img: JazzCashEasyPaisa,
      type: "Jazzcash/ Easypaisa",
    },
    {
      img: CashOnDelivery,
      type: "Cash on delivery",
    },
    {
      img: BankTransfer,
      type: "Bank Transfer",
    },
    {
      img: Maelano,
      type: "Maelano Wallet",
    },
    {
      img: ApplePay,
      type: "Apple Pay",
    },
    {
      img: GooglePay,
      type: "Google Pay",
    },
  ];

  const [selectedMethod, setSelectedMethod] = useState(null);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const handleCheckboxChange = (type) => {
    setSelectedMethod(type);
  };

  const renderPaymentDetails = () => {
    if (!selectedMethod) return null;

    return (
      <>
        <div className="fw-medium mt-3 mb-2">Fill out the details</div>
        <div className={styles.paymentDetails}>
          {selectedMethod === "Credit/Debit Card" && (
            <>
              <div>
                <Input type="text" placeholder="Credit Card Number" />
              </div>
              <div>
                <Input type="text" placeholder="Expiry Date" />
              </div>
              <div>
                <Input type="text" placeholder="CVV" />
              </div>
            </>
          )}
          {selectedMethod === "Paypal" && (
            <div>
              <Input type="email" placeholder="PayPal Email" />
            </div>
          )}
          {selectedMethod === "Jazzcash/ Easypaisa" && (
            <div>
              <Input type="text" placeholder="Mobile Account Number" />
            </div>
          )}
          {selectedMethod === "Cash on delivery" && (
            <>
              <div>
                <Input type="text" placeholder="Recipient Name" />
              </div>
              <div>
                <Input type="text" placeholder="Recipient Phone Number" />
              </div>
            </>
          )}
          {selectedMethod === "Bank Transfer" && (
            <>
              <div>
                <Input type="text" placeholder="Bank Account Number" />
              </div>
              <div>
                <Input type="text" placeholder="Bank Routing Number" />
              </div>
            </>
          )}
          {selectedMethod === "Maelano Wallet" && (
            <div>
              <Input type="text" placeholder="Wallet ID" />
            </div>
          )}
          {selectedMethod === "Apple Pay" && (
            <div>
              <Input type="email" placeholder="Apple Pay Email" />
            </div>
          )}
          {selectedMethod === "Google Pay" && (
            <div>
              <Input type="email" placeholder="Google Pay Email" />
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <div className={styles.mainPaymentMethodContainer}>
      <ScrollToTop />

      <h4 className={styles.mainHeading}>Choose Payment Method</h4>
      <div className={styles.paymentTextBtnWrapper}>
        <p>Choose a payment method. Or you can add from your saved options.</p>
        <div className={styles.paymentOptionsBtnContainer}>
          <Button
            color="link"
            className={styles.paymentBtn}
            onClick={() => setIsDropDownOpen(!isDropDownOpen)}
          >
            Choose from your saved payment options
            <IoIosArrowDown className={styles.arrowIcon} />
          </Button>
          {isDropDownOpen && <DropDown />}
        </div>
      </div>

      <Row className={styles.paymentMethods}>
        {paymentMethods.map((item) => (
          <Col sm="6" lg="4" className={styles.paymentMethodWrapper}>
            <div key={item.type} className={styles.paymentMethod}>
              <div className={styles.imgContainer}>
                <img src={item.img} alt={item.type} className="img-fluid" />
              </div>
              <div>{item.type}</div>
            </div>

            <div className={styles.checkboxWrapper}>
              <input
                className="form-check-input"
                type="checkbox"
                value={item.type}
                id={`flexCheck${item.type}`}
                checked={selectedMethod === item.type}
                onChange={() => handleCheckboxChange(item.type)}
              />
            </div>
          </Col>
        ))}
      </Row>

      {renderPaymentDetails()}

      <div className={styles.finalizeBtnContainer}>
        <Button
          color="info"
          className={styles.paymentBtn}
          onClick={() => setActiveTab('3')}
        >
          Proceed to Finalize
          <RiArrowRightDoubleLine size={28} className={styles.arrowIcon} />
        </Button>
      </div>
    </div>
  );
};

export default PaymentMethod;